export default __webpack_public_path__ + "static/media/debug-modal.878893a8.svg";